'use client';

import { ExclusiveRecruitmentSection as ExclusiveRecruitmentSectionUI } from '@wwe-portal/widget/club-store';
import {
  RecruitmentDialog,
  useRecruitmentDialog,
} from '@wwe-portal/web/components/club-store/modals/RecruitmentDialog';
import { useRosterListSize } from '@wwe-portal/web/utils/club-store/helper';
import { parseRosterItemToProps } from '@wwe-portal/web/utils/club-store/mapper';
import { useLockedRosters } from '../../providers/queries/club-store';
import {
  useRosterFilter,
  useSelectRoster,
} from '../../hooks/club-store/use-roster-filter';
import { useTranslations } from 'next-intl';
import { Dialog, usePortableDialog } from '@wwe-portal/ui/components/dialog';
import { useSubscriptionMutation } from '@wwe-portal/web/providers/queries/subscription.mutation';
import { useSubscriptionQuery } from '@wwe-portal/web/providers/queries/subscription';

import { ChangePlanDialog } from '@wwe-portal/ui/features/subscription/dialog';
import { FilterablePlayerRoster } from './type';
const getRosterRecruitPrice = (roster: FilterablePlayerRoster | undefined) => {
  if (roster == null) return undefined;
  const recruitPrice = Number(roster.e3);
  if (Number.isNaN(recruitPrice)) return undefined;
  return recruitPrice;
};

export const RecruitmentSection = () => {
  const recruitmentModal = usePortableDialog(RecruitmentDialog);
  const { currentPlan } = useSubscriptionQuery();
  const { mutation, upgradeDialogState } = useSubscriptionMutation({
    currentPlan,
  });

  const pageSize = useRosterListSize();
  const { data: rosterItemResponse, isInitialLoading: isLoadingRosters } =
    useLockedRosters();
  const allData = rosterItemResponse?.data.data
    .map(parseRosterItemToProps)
    .map((roster) => ({
      ...roster,
      level: 'G' as const,
      star: 5,
      disabled: roster.e3 == null,
    }))
    .filter((item) => item.id);
  const { roster, selectRosterById, clearSelection } = useSelectRoster({
    rosters: allData ?? [],
    onSelected: () => {
      recruitmentDialog.show();
    },
  });
  const t = useTranslations();

  const rosters = allData?.slice(0, pageSize);

  const total = rosterItemResponse?.data.data.length;

  const {
    show: showRosterFilter,
    remove: hideRosterFilter,
    dialog,
  } = useRosterFilter({
    title: 'NEW RECRUITMENT',
    onClickRoster: selectRosterById,
    hidden: recruitmentModal.visible,
    playerRosters: allData ?? [],
    id: 'recruit-up-filter',
  });

  const recruitmentDialog = useRecruitmentDialog({
    hideRosterFilter,
    subsribeMutation: mutation,
    roster,
    recruitPrice: getRosterRecruitPrice(roster),
    onClose: clearSelection,
  });

  return (
    <>
      <ExclusiveRecruitmentSectionUI
        title={t('clubStore_recruitment_title')}
        description={t('clubStore_recruitment_description')}
        isLoading={isLoadingRosters}
        rosters={rosters}
        total={total}
        onItemClick={selectRosterById}
        onViewMoreRosters={showRosterFilter}
      />
      {dialog}
      {recruitmentDialog.dialog}

      {upgradeDialogState ? (
        <Dialog
          onOpenChange={(value) => {
            if (!value) {
              upgradeDialogState.onClose();
            }
          }}
          open
        >
          <ChangePlanDialog
            buttonContent={upgradeDialogState.buttonContent}
            description={upgradeDialogState.description}
            isUpgrading={mutation.isLoading}
            onChange={upgradeDialogState.onChange}
            onClose={upgradeDialogState.onClose}
          />
        </Dialog>
      ) : null}
    </>
  );
};
